import React, { createContext, useContext, useState, useCallback } from 'react';

const BreadcrumbContext = createContext();

export const BreadcrumbProvider = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState([{ label: 'Home', path: '/' }]);

  // Add breadcrumb dynamically based on label and path passed
  const addBreadcrumb = useCallback((label, path) => {
    setBreadcrumbs((prev) => {
      // Check if the breadcrumb already exists
      const existingIndex = prev.findIndex((breadcrumb) => breadcrumb.path === path);

      if (existingIndex !== -1) {
        // If the breadcrumb exists, slice the array to keep everything up to that index
        return [...prev.slice(0, existingIndex + 1)];
      }

      // If it doesn't exist, add it to the breadcrumbs
      return [...prev, { label, path }];
    });
  }, []);

  // Clear breadcrumbs except for Home
  const clearBreadcrumbs = useCallback(() => {
    setBreadcrumbs([{ label: 'Home', path: '/' }]); // Reset to home breadcrumb
  }, []);

  return (
    <BreadcrumbContext.Provider value={{ breadcrumbs, addBreadcrumb, clearBreadcrumbs }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumbs = () => useContext(BreadcrumbContext);
